import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {MapsCommonService} from "../../services/mapsCommon.service";
import {ResizeService} from "../../../commons/services/resize-service.service";

export class AgentLocationsMapComponent implements IController {
  agent: any;
  highlightedTaskId: any;
  taskIdListType: any;
  onHighlightedChanged: Function
  onAgentLocationChange: Function;

  private taskRef: any;
  private mapTypeIds = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  }
  private siteLocation: any;
  private map: any;
  private taskMarkersControl: any = {}
  private agentMarker: any;
  private agentEvents: any;
  private taskMarkers: any[];
  private polyline: any = {
    path: [],
    visible: true,
    stroke: {
      color: '#2196F3',
      weight: 2,
      opacity: 1
    },
    icons: [{
      icon: {
        path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
      },
      offset: '50px',
      repeat: '150px'
    }]
  };
  private filters: any = {
    agents: {
      enabled: true
    },
    itinerary: {
      enabled: true
    },
    traffic: {
      enabled: false
    },
    satellite: {
      enabled: false
    }
  };
  private isItineraryFilterActive: boolean = true;
  private isInit: boolean = true;
  private isReady: boolean;
  private activeWindow: any;
  private windowParams: any;

  constructor(private $task, private mapsCommonService: MapsCommonService, private resizeService: ResizeService, private $log) {
  }

  $onInit() {
    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.taskRef = this.$task();
    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      events: {
        idle: (map) => {
          if (!this.isReady) {
            this.isReady = true;
            google.maps.event.trigger(map, 'resize');
            this.resizeService.resize();
            this.centerMap();
          }
        }
      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId[this.mapTypeIds.roadmap]
      },
      bounds: {}
    };
    this.agentMarker = {
      options: {
        icon: this.mapsCommonService.getAgentIcon(this.agent),
        visible: true,
        draggable: true
      }
    };
    this.agentEvents = {
      dragend: (marker, eventName, model) => {
        const lat = marker.position.lat(),
          lng = marker.position.lng();

        this.onAgentLocationChange({lat: lat, lng: lng});
      }
    };

    this.taskMarkers = [];
    this.polyline.path = [];

    if (this.activeWindow) {
      this.clearActiveWindow();
    }

    if (this.agent) {
      this.initTaskMarkers(this.agent);
    }
  }

  $onChanges(changes) {
    //Agent changed
    if (changes.agent && !changes.agent.isFirstChange()) {
      const currentAgent = changes.agent.currentValue,
        previousAgent = changes.agent.previousValue;

      if (!currentAgent ||
        !previousAgent ||
        !_.isEqual(currentAgent.id, previousAgent.id) ||
        !_.isEqual(currentAgent.itineraryInfo[this.taskIdListType], previousAgent.itineraryInfo[this.taskIdListType])) {
        this.isInit = true;
        this.$onInit();
      }

      this.agentMarker.options.icon = this.mapsCommonService.getAgentIcon(this.agent);
    }

    //Task clicked (Active window)
    if (changes.highlightedTaskId && !changes.highlightedTaskId.isFirstChange()) {
      const currentHighlightedTaskId = changes.highlightedTaskId.currentValue,
        previousHighlightedTaskId = changes.highlightedTaskId.previousValue;

      if (!_.isEqual(currentHighlightedTaskId, previousHighlightedTaskId)) {
        const taskMarkerForHighlight = _.find(this.taskMarkers, (marker) => {
          return _.isEqual(marker.id, currentHighlightedTaskId);
        });
        if (taskMarkerForHighlight) {
          this.activateInfoWindow(taskMarkerForHighlight);
        }
      }
    }

    //Bundle / Regular view
    if (changes.taskIdListType && !changes.taskIdListType.isFirstChange()) {
      const currentTaskIdListType = changes.taskIdListType.currentValue,
        previousTaskIdListType = changes.taskIdListType.previousValue;

      if (!_.isEqual(currentTaskIdListType, previousTaskIdListType)) {
        this.$onInit();
      }
    }
  }

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic.enabled = false;
    }
  }

  centerMap() {
    const markers = this.getAllMarkers();

    if (_.get(this.agent, 'lastKnownLocation')) {
      const agentMarker = new google.maps.MVCObject();
      agentMarker.set('coords', {
        'latitude': this.agent.lastKnownLocation.coordinates.latitude,
        'longitude': this.agent.lastKnownLocation.coordinates.longitude
      });
      markers.push(agentMarker);
    }

    this.mapsCommonService.centerMapByBounds(this.map, markers);
  }

  sortTaskMarkers(taskMarkers, taskIds) {
    return _.sortBy(taskMarkers, [function (taskMarker) {
      var index = _.indexOf(taskIds, taskMarker.id) + 1;
      return index - 1;
    }]);
  }

  getPolylinePath(allMarkers) {
    var path = [];
    _.forEach(allMarkers, function (marker) {
      path.unshift(
        {
          latitude: marker.coords.latitude,
          longitude: marker.coords.longitude
        }
      )
    });
    return path;
  }

  toggleShowItinerary() {
    if (this.taskMarkersControl) {
      const taskMarkersControl = this.taskMarkersControl.getGMarkers();

      _.forEach(taskMarkersControl, (m) => {
        m.setVisible(this.isItineraryFilterActive);
      });

      this.polyline.visible = !this.polyline.visible
    }
  }

  onTaskMarkerClick(marker, eventName, model) {
    //Highlight Tasks
    this.onHighlightedChanged({
      serviceId: model.serviceId,
      taskId: model.id
    });
  }

  clearActiveWindow() {
    this.activeWindow.show = false;
    this.windowParams = {}
  }

  activateInfoWindow(markerModel) {
    if (this.activeWindow && !_.isEqual(this.activeWindow, markerModel)) {
      this.activeWindow.show = false;
      this.activeWindow = {};
    }

    //Data passed to info-window
    this.windowParams = {
      taskSpec: markerModel.taskSpec
    };

    if (markerModel.bundleInfo) {
      _.set(this.windowParams, 'bundleInfo', markerModel.bundleInfo)
    }

    markerModel.show = !markerModel.show;
    this.activeWindow = markerModel;
  }

  private initTaskMarkers(agent) {
    const taskIds = agent.itineraryInfo[this.taskIdListType];

    this.taskRef.$asyncValues(taskIds)
      .then((allTasks) => {
        const allTaskMarkers = this.mapsCommonService.getRouteTaskMarkers(allTasks, this.filters.itinerary.enabled)
        const sortedTaskMarkers = this.sortTaskMarkers(allTaskMarkers, taskIds);

        this.taskMarkers = sortedTaskMarkers;
        this.polyline.path = this.getPolylinePath(sortedTaskMarkers);

        if (this.isInit) {
          this.isInit = false;
          this.centerMap();
        }
      })
      .catch((error) => {
        this.$log.error('Failed to get tasks @itineraryMap@_initTaskMarkers', error);
      })
      .finally(() => {
        this.resizeService.resize();
      })
  }

  private getAllMarkers() {
    return this.taskMarkers.concat(this.agent || [])
  }

}


angular
  .module('bringoz.admin.map')
  .component('agentLocationsMap', {
    bindings: {
      agent: '<',
      highlightedTaskId: '<',
      taskIdListType: '<',
      onHighlightedChanged: '&',
      onAgentLocationChange: '&'
    },
    template: require('./agent-locations-map.html').default,
    controller: AgentLocationsMapComponent
  });
